export default __webpack_public_path__ + "textEditor.0c1020d6323ecd3191a24542c3c47ccc.png";